import React, {  useRef, useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux"; 
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"  
import { useNavigate } from 'react-router-dom'; 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT,DEFAULTSUBSTORE } from "constants/variables";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box';  
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';  
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import IconButton from '@mui/material/IconButton'; 
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField'; 
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { NumericFormat } from 'components/utils/NumericFormat';
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import "css/generalSettings.css"; 
import PurchaseSearchStores from "pages/purchases/editOrNewPurchaseDelivery/PurchaseSearchStores";
import PurchaseSearchStoresAddresses from "pages/purchases/editOrNewPurchaseDelivery/PurchaseSearchStoresAddress";
import PurchaseSearchSHEETS from "pages/purchases/editOrNewPurchaseDelivery/PurchaseSearchSheet";
import PurchaseSelectArticle from "pages/purchases/editOrNewPurchaseDelivery/PurchaseSelectArticle";
import TableSortingPurchaseDeliveryArticleList from "pages/purchases/editOrNewPurchaseDelivery/SortingTablesArticlesList";
import PurchaseDeliverySearchArticles from "pages/purchases/editOrNewPurchaseDelivery/PurchaseSearchArticles";
import PropTypes from 'prop-types';  

const initialStatePurchaseDelivery = {
  "id" : "",
  "defaultStore_id":0, 
  "tradename": "",
  "useraccount_id":0,
  "username": "",
  "substore_id":0, 
  "substore_name": "",

  "purchasenote":0,  
  "ownnumberpurchase":"", 
  "datepurchase": null, 
 
  "opt_tras_store_id" : 0,
  "opt_tras_documnettype_id" : 1,
  "opt_tras_documentid" : "",
  "opt_tras_tradename" : "",
  "opt_tras_roadtype_id" :  74,
  "opt_tras_street" : "",
  "opt_tras_country_id":  1,
  "opt_tras_country_name": "",
  "opt_tras_province_id": 30,
  "opt_tras_province_name": "",
  "opt_tras_postalcode_id": 6911,
  "opt_tras_postalcode_code":"",
  "opt_tras_postalcode_name": "",
  "opt_tras_community_id":  6, 
  "opt_tras_community_name": "", 
  "opt_tras_email":"",
  "opt_tras_licenseplate":"",
  "vehiclestore_frame":"", 
  "vehicle_marca":"", 
  "vehicle_model":"", 
 
  "observations": "",
  "totalpurchasedelivery": 0,
  "totaldiscountpurchasedelivery": 0,
  "totaltaxespurchasedelivery":0,
  "totalNetoPurchasedelivery":0,  
  "payment_id" : 1 ,
  "payment_code": "",
  "payment_namees": "",
  "payment_nameen": "",

  "linespurchasedelivery":[]
};

const initialToSelect = [{
  "id": "",
  "code": "",
  "namees": "",
  "nameen": "",
}];
 
const initialMarcaToSelect = [{
  "id": "",
  "marca": ""
}];

const initialModelToSelect = [{
  "id": "",
  "model": ""
}];

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0,
    "province_name":""
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialArticlesToSelect = {
  "id": 0,
  "indexrowarticle":0, 
  "defaultStore_id": 0,
  "tradename": "",
  "substore_id": 0,
  "substore_name": "",
  "purchase_id":0,
  "article_id":0,
  "article_code": "",
  "article_namees": "",
  "article_nameen": "",
  "applytypesofsize":false,
  "applycolor":false,
  "applynumserial":false,
  "isnewpiece":true,
  "typeofsize_id":0,
  "typeofsize_namees": "",
  "typeofsize_nameen": "",
  "typeofsize_symbolsizes": "",
  "articlecolor_id":0,
  "articlecolor_namees": "",
  "articlecolor_nameen": "",
  "articlecolor_codehex": "",
  "serialnumber_id":0,
  "serialnumber":"",
  "line_description": "",
  "datepurchase": null,
  "amount": 1,
  "estimatedprice": 0, 
  "discount":0,
  "tax":0,
  "taxincluded":false, 
  "total":0, 
}; 

const initialColorToSelect= [{
  "id" : 0,
  "article_id": 0,
  "enablecolorarticle":true,
  "articlecolor_id": 0,
  "articlecolor_namees" : "",
  "articlecolor_nameen" : "",
  "articlecolor_codehex":""
}];

const initialTypesOfSizeToSelect = [{
  "id" : 0,
  "article_id": 0,
  "enabletypesofsizearticle":true,
  "articlesize_id": 0,
  "articlesize_namees" : "",
  "articlesize_nameen" : "",
  "articlesize_symbolsizes":""
}];

const initialSerialNumbersToSelect = [{
  "id": 0,
  "article_id": 0,
  "store_id": 0,
  "store_name": 0,
  "substore_id": 0,
  "substore_name": "",
  "typeofsize_id": 0,
  "typeofsize_namees": "",
  "typeofsize_nameen": "",
  "typeofsize_symbolsizes": "", 
  "color_id": 0,
  "color_namees": "",
  "color_nameen": "",
  "color_codehex": "",
  "serialnumber": ""
}];

const PurchaseDeliveryEditOrCreate = ({id, showModalPurchasesDeliverySettings,typeOfList}) => {
  const {t,i18n} = useTranslation(['listDataPurchases']);
  const token = useSelector((state) => state.loginUser.token);  
  const roles = useSelector((state) => state.loginUser.roles);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  
  const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
  const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
  const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
  const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
  const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
  const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
  const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
  const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
  const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
  const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
  const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
   
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const [formPurchaseDelivery, setFormPurchaseDelivery] = useState(initialStatePurchaseDelivery);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});  
  const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
  const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
  const [showModalSearchSHEETS, setShowModalSearchSHEETS] = useState(false); 
  const [showModalSearchArticles, setShowModalSearchArticles] = useState(false); 
  const [openDeleteRowArticles,setOpenDeleteRowArticles]= useState(false);
  const [idCodeDeletePurchaseDelivery, setIdCodeDeletePurchaseDelivery] = useState(DELETE_CODE);
  const [editRowArticles, setEditRowArticles] = useState(initialArticlesToSelect); 
  const [roadTypesToSelect,setRoadTypesToSelect]= useState(initialToSelect);
  const [paymenetTypeSelect,setPaymenetTypeSelect]= useState(initialToSelect);    
  const [newArticle, setNewArticle] = useState(initialArticlesToSelect); 
  const [errorNewArticle, setErrorNewArticle] =  useState({});
  const [foundArticle, setFoundArticle ]= useState(false);
  const [foundNumSerial, setFoundNumSerial ]= useState(false);
  const [colorToSelect,setColorToSelect]= useState(initialColorToSelect);
  const [typesOfSizeToSelect,setTypesOfSizeToSelect]= useState(initialTypesOfSizeToSelect);
  const [serialNumbersToSelect,setSerialNumbersToSelect]= useState(initialSerialNumbersToSelect);
  const [marcaToSelect,setMarcaToSelect]= useState(initialMarcaToSelect);  
  const [filteredMarca, setFilteredMarca] = useState([]); // Opciones filtradas
  const [highlightedIndexMarca, setHighlightedIndexMarca] = useState(-1); // Índice de la opción resaltada   
  const [modelToSelect,setModelToSelect]= useState(initialModelToSelect);  
  const [filteredModel, setFilteredModel] = useState([]); // Opciones filtradas
  const [highlightedIndexModel, setHighlightedIndexModel] = useState(-1); // Índice de la opción resaltada 
  
  const [postalCodeOptToSelect,setPostalCodeOptToSelect]= useState(initialPostalCodesToSelect);  
  const [filteredpostalCodeOpt, setFilteredpostalCodeOpt] = useState([]); // Opciones filtradas
  const [highlightedIndexPostalCodeOpt, setHighlightedIndexPostalCodeOpt] = useState(-1); // Índice de la opción resaltada 
  const [documentIdOptToSelect,setDocumentIdOptToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredDocumentIdOpt, setFilteredDocumentIdOpt] = useState([]); // Opciones filtradas
  const [highlightedIndexDocumentIdOpt, setHighlightedIndexDocumentIdOpt] = useState(-1); // Índice de la opción resaltada 
  const [tradenameOptToSelect,setTradenameOptToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredTradenamedOpt, setFilteredTradenamedOpt] = useState([]); // Opciones filtradas
  const [highlightedIndexTradenamedOpt, setHighlightedIndexTradenamedOpt] = useState(-1); // Índice de la opción resaltada 
  
  const ddRefMarca = useRef(null);
  const ddRefModel = useRef(null);
  const ddRefDocId = useRef(null);
  const ddRefTrade = useRef(null);
  const ddRefPostal = useRef(null);

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalPurchasesDeliverySettings) {
        setFormPurchaseDelivery(formPurchaseDelivery => ({
          ...formPurchaseDelivery,
          linespurchasedelivery: [],
        }));
        setFormPurchaseDelivery(initialStatePurchaseDelivery);
        setIsLoadingErrorData(false);
        setErrorsForm({});  
        setShowModalSearchStores(false);
        setShowModalSearchStoresAddress(false);
        setShowModalSearchSHEETS(false);
        setShowModalSearchArticles(false);
        setOpenDeleteRowArticles(false);
        setIdCodeDeletePurchaseDelivery(DELETE_CODE);
        setEditRowArticles(initialArticlesToSelect);
        setRoadTypesToSelect(initialToSelect);
        setPaymenetTypeSelect(initialToSelect);
        setNewArticle(initialArticlesToSelect);
        setErrorNewArticle({});
        setFoundArticle(false);
        setFoundNumSerial(false);
        setColorToSelect(initialColorToSelect);
        setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
        setSerialNumbersToSelect(initialSerialNumbersToSelect);
        setMarcaToSelect(initialMarcaToSelect);
        setFilteredMarca([]);
        setHighlightedIndexMarca(-1);
        setModelToSelect(initialModelToSelect);
        setFilteredModel([]);
        setHighlightedIndexModel(-1);
        setPostalCodeOptToSelect(initialPostalCodesToSelect);
        setFilteredpostalCodeOpt([]);
        setHighlightedIndexPostalCodeOpt(-1);
        setDocumentIdOptToSelect(initialDocumentIdToSelect);
        setFilteredDocumentIdOpt([]);
        setHighlightedIndexDocumentIdOpt(-1);
        setTradenameOptToSelect(initialDocumentIdToSelect);
        setFilteredTradenamedOpt([]);
        setHighlightedIndexTradenamedOpt(-1);
        dispatch(setLoading(false));
        navigate(typeOfList==="1"?"/purchasedeliveryin":"/purchasedeliveryout");
      }
    },
    [
     setFormPurchaseDelivery,
      setIsLoadingErrorData,
      setErrorsForm,
      setShowModalSearchStores,
      setShowModalSearchStoresAddress,
      setShowModalSearchSHEETS,
      setShowModalSearchArticles,
      setOpenDeleteRowArticles,
      setIdCodeDeletePurchaseDelivery,
      setEditRowArticles,
      setRoadTypesToSelect,
      setPaymenetTypeSelect,
      setNewArticle,
      setErrorNewArticle,
      setFoundArticle,
      setFoundNumSerial,
      setColorToSelect,
      setTypesOfSizeToSelect,
      setSerialNumbersToSelect,
      setMarcaToSelect,
      setFilteredMarca,
      setHighlightedIndexMarca,
      setModelToSelect,
      setFilteredModel,
      setHighlightedIndexModel,
      setPostalCodeOptToSelect,
      setFilteredpostalCodeOpt,
      setHighlightedIndexPostalCodeOpt,
      setDocumentIdOptToSelect,
      setFilteredDocumentIdOpt,
      setHighlightedIndexDocumentIdOpt,
      setTradenameOptToSelect,
      setFilteredTradenamedOpt,
      setHighlightedIndexTradenamedOpt,
       showModalPurchasesDeliverySettings,
      navigate,
      typeOfList,
      dispatch,
      DELETE_CODE
    ]
  );
  
  const handleCloseDataEditPurchaseDelivery = () => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      linespurchasedelivery: [],
    }));
    setFormPurchaseDelivery(initialStatePurchaseDelivery);
    setIsLoadingErrorData(false);
    setErrorsForm({});  
    setShowModalSearchStores(false);
    setShowModalSearchStoresAddress(false);
    setShowModalSearchSHEETS(false);
    setShowModalSearchArticles(false);
    setOpenDeleteRowArticles(false);
    setIdCodeDeletePurchaseDelivery(DELETE_CODE);
    setEditRowArticles(initialArticlesToSelect);
    setRoadTypesToSelect(initialToSelect);
    setPaymenetTypeSelect(initialToSelect);
    setNewArticle(initialArticlesToSelect);
    setErrorNewArticle({});
    setFoundArticle(false);
    setFoundNumSerial(false);
    setColorToSelect(initialColorToSelect);
    setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
    setSerialNumbersToSelect(initialSerialNumbersToSelect);
    setMarcaToSelect(initialMarcaToSelect);
    setFilteredMarca([]);
    setHighlightedIndexMarca(-1);
    setModelToSelect(initialModelToSelect);
    setFilteredModel([]);
    setHighlightedIndexModel(-1);
    setPostalCodeOptToSelect(initialPostalCodesToSelect);
    setFilteredpostalCodeOpt([]);
    setHighlightedIndexPostalCodeOpt(-1);
    setDocumentIdOptToSelect(initialDocumentIdToSelect);
    setFilteredDocumentIdOpt([]);
    setHighlightedIndexDocumentIdOpt(-1);
    setTradenameOptToSelect(initialDocumentIdToSelect);
    setFilteredTradenamedOpt([]);
    setHighlightedIndexTradenamedOpt(-1);
    dispatch(setLoading(false));
    navigate(typeOfList==="1"?"/purchasedeliveryin":"/purchasedeliveryout");
	};
  
  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
  };
    
  // Dentro del componente
  const debouncedHandleSearchMarca = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredMarca([]);
      setHighlightedIndexMarca(-1);
      return;
    }
    const filtered = marcaToSelect
      .filter(vehicle => vehicle && vehicle.marca)
      .filter(vehicle => {
        const vehiclestoremarca= vehicle.marca.toUpperCase();
        return vehiclestoremarca.includes(upperValue);
      })
      .slice(0, 40); // limitar resultados
      setFilteredMarca(filtered);
      setHighlightedIndexMarca(0);
  }, 300);

  const handleSelectMarca = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      vehicle_marca: (vehicle.marca || "") 
    }));
    setFilteredMarca([]);
    setHighlightedIndexMarca(-1);
  }; 

  const handleKeyDownMarca = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredMarca.length === 0 && formPurchaseDelivery.vehicle_marca.trim() === "") {
        setFilteredMarca(marcaToSelect);
        setHighlightedIndexMarca(0);
      } else {
        setHighlightedIndexMarca((prevIndex) => {
          const nextIndex = prevIndex < filteredMarca.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex,ddRefMarca);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexMarca((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid,ddRefMarca);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexMarca >= 0) {
      if (highlightedIndexMarca >= 0 && highlightedIndexMarca < filteredMarca.length) {
        handleSelectMarca(filteredMarca[highlightedIndexMarca]);
      }
    } else if (event.key === "Escape") {
      const isValid = marcaToSelect.some((vehicle) => {
        if (!vehicle || !vehicle.marca) return false; 
        const normalizedVehicleMarca = vehicle.marca.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicleMarca = formPurchaseDelivery.vehicle_marca.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicleMarca === normalizedInputVehicleMarca;
      }); 
      if (!isValid) {
        setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          vehicle_marca: "",
        }));
      } 
      setFilteredMarca([]);
      setHighlightedIndexMarca(-1);
    }
  }; 

  // Dentro del componente
  const debouncedHandleSearchModel = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredModel([]);
      setHighlightedIndexModel(-1);
      return;
    }
    const filtered = modelToSelect
      .filter(vehicle => vehicle && vehicle.model)
      .filter(vehicle => {
        const vehiclestoremodel = vehicle.model.toUpperCase();
        return vehiclestoremodel.includes(upperValue);
      })
      .slice(0, 40); // limitar resultados
      setFilteredModel(filtered);
      setHighlightedIndexModel(0);
  }, 300);

  const handleSelectModel = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      vehicle_model: (vehicle.model || "") 
    }));
    setFilteredModel([]);
    setHighlightedIndexModel(-1);
  }; 

  const handleKeyDownModel = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredModel.length === 0 && formPurchaseDelivery.vehicle_model.trim() === "") {
        setFilteredModel(modelToSelect);
        setHighlightedIndexModel(0);
      } else {
        setHighlightedIndexModel((prevIndex) => {
          const nextIndex = prevIndex < filteredModel.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex,ddRefModel);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexModel((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid,ddRefModel);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexModel >= 0) {
      if (highlightedIndexModel >= 0 && highlightedIndexModel < filteredModel.length) {
        handleSelectModel(filteredModel[highlightedIndexModel]);
      }
    } else if (event.key === "Escape") {
      const isValid = modelToSelect.some((vehicle) => {
        if (!vehicle || !vehicle.model) return false; 
        const normalizedVehicleModel = vehicle.model.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicleModel = formPurchaseDelivery.vehicle_model.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicleModel === normalizedInputVehicleModel;
      }); 
      if (!isValid) {
        setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          vehicle_model: "",
        }));
      } 
      setFilteredModel([]);
      setHighlightedIndexModel(-1);
    }
  };

  // Dentro del componente
  const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
        setFilteredpostalCodeOpt([]);
        setHighlightedIndexPostalCodeOpt(-1);
    return;
    }
    const filtered = postalCodeOptToSelect
    .filter(postal => postal && postal.postalcode)
    .filter(postal => {
        const postalcode = postal.postalcode.toUpperCase();
        return postalcode.startsWith(upperValue);
    })
    .slice(0, 20); // limitar resultados
    setFilteredpostalCodeOpt(filtered);
    setHighlightedIndexPostalCodeOpt(0);
  }, 300); 

  const handleSelectPostalCodeOpt = (postal) => {
      if (!postal) return; // Validación adicional para evitar errores
      setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          opt_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
          opt_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
          opt_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
          opt_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE),
          opt_tras_province_name: postal.province_name || DEFAULTPROVINCE_NAME
      }));
      setFilteredpostalCodeOpt([]);
      setHighlightedIndexPostalCodeOpt(-1);
  }; 
  
  const handleKeyDownDPostalCodeOpt = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredpostalCodeOpt.length === 0 && formPurchaseDelivery.opt_tras_postalcode_code.trim() === "") {
          setFilteredpostalCodeOpt(postalCodeOptToSelect); 
          setHighlightedIndexPostalCodeOpt(0);
      } else {
          setHighlightedIndexPostalCodeOpt((prevIndex) => {
          const nextIndex = prevIndex < filteredpostalCodeOpt.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex,ddRefPostal);
          return nextIndex;
          });
      }
    } else if (event.key === "ArrowUp") {
          setHighlightedIndexPostalCodeOpt((prevIndex) => {
              const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
              // Desplaza al elemento anterior
              scrollToElement(prevIndexValid,ddRefPostal);
              return prevIndexValid;
          });
      } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeOpt >= 0) {
          if (highlightedIndexPostalCodeOpt >= 0 && highlightedIndexPostalCodeOpt < filteredpostalCodeOpt.length) {
              handleSelectPostalCodeOpt(filteredpostalCodeOpt[highlightedIndexPostalCodeOpt]);
          }
      } else if (event.key === "Escape") {
          const isValid = postalCodeOptToSelect.some((postal) => {
              if (!postal || !postal.postalcode) return false; 
              const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
              const normalizedInputId = formPurchaseDelivery.opt_tras_postalcode_code.toUpperCase();
              return normalizedPostalCodeId === normalizedInputId;
          }); 
      if (!isValid) { 
          setFormPurchaseDelivery((formPurchaseDelivery) => ({
              ...formPurchaseDelivery,
              opt_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
              opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
              opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
              opt_tras_province_id: Number(DEFAULTPROVINCE),
              opt_tras_province_name: DEFAULTPROVINCE_NAME
          }));
      } 
      setFilteredpostalCodeOpt([]);
      setHighlightedIndexPostalCodeOpt(-1);
      }
  };

  // Dentro del componente
  const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
      const upperValue = searchValue.toUpperCase();
      if (upperValue.trim() === "") {
          setFilteredDocumentIdOpt([]);
          setHighlightedIndexDocumentIdOpt(-1);
          return;
      }
      const filtered = documentIdOptToSelect
          .filter(store => store && store.documentid)
          .filter(store => {
          const documentId = store.documentid.toUpperCase();
          return documentId.includes(upperValue);
          })
          .slice(0, 20); // limitar resultados
      setFilteredDocumentIdOpt(filtered);
      setHighlightedIndexDocumentIdOpt(0);
  }, 300);

  const handleSelectDocumentIdOpt = (store) => {
      if (!store) return; // Validación adicional para evitar errores
      setFormPurchaseDelivery((formPurchaseDelivery) => ({
      ...formPurchaseDelivery,
      opt_tras_documentid: store.documentid || "",
      }));
      setFilteredDocumentIdOpt([]);
      setHighlightedIndexDocumentIdOpt(-1);
  }; 

  const handleKeyDownDocumentIdOpt = (event) => {
      if (event.key === "ArrowDown") {
      if (filteredDocumentIdOpt.length === 0 && formPurchaseDelivery.opt_tras_documentid.trim() === "") {
          setFilteredDocumentIdOpt(documentIdOptToSelect);
          setHighlightedIndexDocumentIdOpt(0);
      } else {
          setHighlightedIndexDocumentIdOpt((prevIndex) => {
          const nextIndex = prevIndex < filteredDocumentIdOpt.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex,ddRefDocId);
          return nextIndex;
          });
      }
      } else if (event.key === "ArrowUp") {
      setHighlightedIndexDocumentIdOpt((prevIndex) => {
          const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
          // Desplaza al elemento anterior
          scrollToElement(prevIndexValid,ddRefDocId);
          return prevIndexValid;
      });
      } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdOpt >= 0) {
      if (highlightedIndexDocumentIdOpt >= 0 && highlightedIndexDocumentIdOpt < filteredDocumentIdOpt.length) {
          handleSelectDocumentIdOpt(filteredDocumentIdOpt[highlightedIndexDocumentIdOpt]);
      }
      } else if (event.key === "Escape") {
      const isValid = documentIdOptToSelect.some((store) => {
          if (!store || !store.documentid) return false; 
          const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
          const normalizedInputId = formPurchaseDelivery.opt_tras_documentid.toUpperCase();
          return normalizedStoreId === normalizedInputId;
      }); 
      if (!isValid) {
          setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          opt_tras_documentid: "",
          }));
      } 
      setFilteredDocumentIdOpt([]);
      setHighlightedIndexDocumentIdOpt(-1);
      }
  };

  // Dentro del componente
  const debouncedHandleSearchTradename= useDebounce((searchValue) => {
      const upperValue = searchValue.toUpperCase();
      if (upperValue.trim() === "") {
          setFilteredTradenamedOpt([]);
          setHighlightedIndexTradenamedOpt(-1);
      return;
      }
      const filtered = tradenameOptToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
          const tradename = store.tradename.toUpperCase();
          return tradename.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredTradenamedOpt(filtered);
      setHighlightedIndexTradenamedOpt(0);
  }, 300); 

  const handleSelectTradeNameOpt = (store) => {
      if (!store) return; // Validación adicional para evitar errores
      setFormPurchaseDelivery((formPurchaseDelivery) => ({
      ...formPurchaseDelivery,
      opt_tras_tradename: store.tradename || "",
      opt_tras_documentid: store.documentid || formPurchaseDelivery.opt_tras_documentid,
      
      }));
      setFilteredTradenamedOpt([]);
      setHighlightedIndexTradenamedOpt(-1);
  }; 

  const handleKeyDownTradenameOpt = (event) => {
      if (event.key === "ArrowDown") {
      if (filteredTradenamedOpt.length === 0 && formPurchaseDelivery.opt_tras_tradename.trim() === "") {
          setFilteredTradenamedOpt(tradenameOptToSelect);
          setHighlightedIndexTradenamedOpt(0);
      } else {
          setHighlightedIndexTradenamedOpt((prevIndex) => {
          const nextIndex = prevIndex < filteredTradenamedOpt.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex,ddRefTrade);
          return nextIndex;
          });
      }
      } else if (event.key === "ArrowUp") {
      setHighlightedIndexTradenamedOpt((prevIndex) => {
          const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
          // Desplaza al elemento anterior
          scrollToElement(prevIndexValid,ddRefTrade);
          return prevIndexValid;
      });
      } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedOpt >= 0) {
      if (highlightedIndexTradenamedOpt >= 0 && highlightedIndexTradenamedOpt < filteredTradenamedOpt.length) {
          handleSelectTradeNameOpt(filteredTradenamedOpt[highlightedIndexTradenamedOpt]);
      }
      } else if (event.key === "Escape") {
      const isValid = tradenameOptToSelect.some((store) => {
          if (!store || !store.tradename) return false; 
          const normalizedTradeName = store.tradename.toUpperCase();
          const normalizedInputTradeName = formPurchaseDelivery.opt_tras_tradename.toUpperCase();
          return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
          setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          opt_tras_tradename: "",
          }));
      } 
      setFilteredTradenamedOpt([]);
      setHighlightedIndexTradenamedOpt(-1);
      }
  }; 

  // Función para desplazar el contenedor
  const scrollToElement = (index, ref) => {
    const dropdown = ref?.current;
    const item = dropdown?.children?.[index];
    if (item) item.scrollIntoView({ behavior: "smooth", block: "nearest" });
  };


  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setHighlightedIndexMarca(-1); 
      setFilteredMarca([]); 
      setHighlightedIndexModel(-1); 
      setFilteredModel([]); 
      setFilteredpostalCodeOpt([]);
      setHighlightedIndexPostalCodeOpt(-1);
      setFilteredDocumentIdOpt([]);
      setHighlightedIndexDocumentIdOpt(-1);
      setFilteredTradenamedOpt([]);
      setHighlightedIndexTradenamedOpt(-1);  
    }
  }, []); 
  
  const handleChangeDataEditPurchaseDelivery = (e) => {
    const { name, value } = e.target;
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      [name]: value,
    }));
  };

  const handleBlurDataEditPurchaseDelivery = (e) => {
    handleChangeDataEditPurchaseDelivery(e);
    setErrorsForm(validatePurchaseDelivery());
  }; 

  const handleBlurSelectDate = (e) => {
    handleChangeSelectDate(e);
    setErrorsForm(validatePurchaseDelivery());
  };

  const handleChangeSelectDate = (event) => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      datepurchase: event!==null?new Date(event):null
    }));
  };
 
 
  const withValueCap3 = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000000) return true;
    return false;
  };
 

  const deleteVehicleData = (event) => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      opt_tras_licenseplate:"",
      vehiclestore_frame: "",
      vehicle_marca:"",
      vehicle_model: ""
       
    }));
    setErrorsForm(validatePurchaseDelivery());
  };

  const deleteDateOptTras = (event) => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      opt_tras_store_id:0,
      opt_tras_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
      opt_tras_documentid:"",
      opt_tras_tradename: "",
      opt_tras_roadtype_id: Number(DEFAULTROADTYE),
      opt_tras_street: "",
      opt_tras_country_id: Number(DEFAULTCOUNTRY),
      opt_tras_country_name:DEFAULTCOUNTRY_NAME,
      opt_tras_province_id: Number(DEFAULTPROVINCE),
      opt_tras_province_name:DEFAULTPROVINCE_NAME,
      opt_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
      opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
      opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
      opt_tras_community_id: Number(DEFAULTCOMMUNITY),
      opt_tras_community_name: DEFAULTCOMMUNITY_NAME,
      opt_tras_email: "",
    }));
    setErrorsForm(validatePurchaseDelivery());
  };

   const deleteDataSteetOptTras = (event) => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
        opt_tras_roadtype_id: Number(DEFAULTROADTYE),
        opt_tras_street: "",
        opt_tras_country_id: Number(DEFAULTCOUNTRY),
        opt_tras_country_name:DEFAULTCOUNTRY_NAME,
        opt_tras_province_id: Number(DEFAULTPROVINCE),
        opt_tras_province_name:DEFAULTPROVINCE_NAME,
        opt_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
        opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
        opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
        opt_tras_community_id: Number(DEFAULTCOMMUNITY),
        opt_tras_community_name: DEFAULTCOMMUNITY_NAME, 
    }));
    setErrorsForm(validatePurchaseDelivery());
  };

  const searchPurchaseStore = (event) => {
    setShowModalSearchStores(true);
  };

  const searchPurchaseStoreAddress = (event) => {
    setShowModalSearchStoresAddress(true);
  };

  const searchPurchaseSHEETS = (event) => {
    setShowModalSearchSHEETS(true);
  };

  const handleCancelDeleteRow = () => { 
    setEditRowArticles(initialArticlesToSelect); 
    dispatch(setLoading(false));  
    setIsLoadingErrorData(false);
    setIdCodeDeletePurchaseDelivery(DELETE_CODE);
    setOpenDeleteRowArticles(false);
  };

  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDeletePurchaseDelivery(value);
  };

  const handleCloseDeleteRow = (e) => {
    e.preventDefault();
    if (idCodeDeletePurchaseDelivery!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      
      let indexDelete=formPurchaseDelivery.linespurchasedelivery.findIndex(((item) => item.indexrowarticle === editRowArticles.indexrowarticle));
      if ( indexDelete !== -1 ) {
        formPurchaseDelivery.linespurchasedelivery.splice( indexDelete, 1 );
      }
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
      })) 
      let totalNeto=0; 
      formPurchaseDelivery.linespurchasedelivery.map((item)=>{
        return totalNeto+=item.total;
      });
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
        totalNetoPurchasedelivery:totalNeto
       }));
      setIdCodeDeletePurchaseDelivery(DELETE_CODE);
      setOpenDeleteRowArticles(false);
    }
  };

  const handleSubmitDataEditPurchaseEdit = () => {
    const errors = validatePurchaseDelivery();
    setErrorsForm(errors); 
    if ((Object.keys(errors).length === 0) 
        && formPurchaseDelivery.linespurchasedelivery!==undefined  
        && formPurchaseDelivery.linespurchasedelivery.length>0 ) {
      
      handleCloseDataEditPurchaseDelivery();
      const fetchData = async () => {
        let isMounted = true;
        try {
          const getData = (id !== "0" && id !== 0)
          ? await helpHttp().put2(ENDPOINT, `purchasedelivery/updatepurchasedelivery`, token, (typeOfList==="1" )?"1":"2",formPurchaseDelivery)
          : await helpHttp().post2(ENDPOINT, `purchasedelivery/savepurchasedelivery`, token, (typeOfList==="1" )?"1":"2",formPurchaseDelivery);
          if (getData.status === "OK") { 
            dispatch(successErrorAction(t('Text_SaveData'))); 
          } else {
            if (isMounted ) {
              dispatch(warningErrorAction(t(getData.cause)));
            }
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
        return () => { isMounted = false;};
      };
      fetchData(); 
    }else{
      if (errors.ownnumberpurchase) {
        dispatch(warningErrorAction(t(errors.ownnumberpurchase)));
      } else if (errors.opt_tras_documentid) {
        dispatch(warningErrorAction(t(errors.opt_tras_documentid)));
      } else if (errors.opt_tras_street) {
        dispatch(warningErrorAction(t(errors.opt_tras_street)));
      } else if (errors.opt_tras_email) {
        dispatch(warningErrorAction(t(errors.opt_tras_email)));
      } else if (errors.opt_tras_licenseplate) {
        dispatch(warningErrorAction(t(errors.opt_tras_licenseplate)));
      } else if (errors.vehiclestore_frame) {
        dispatch(warningErrorAction(t(errors.vehiclestore_frame)));
      } else if (errors.vehicle_marca) {
        dispatch(warningErrorAction(t(errors.vehicle_marca)));
      } else if (errors.vehicle_model) {
        dispatch(warningErrorAction(t(errors.vehicle_model)));
      } else if (errors.observations) {
        dispatch(warningErrorAction(t(errors.observations)));
      } else if (errors.opt_tras_tradename) {
        dispatch(warningErrorAction(t(errors.opt_tras_tradename)));
      } else if (errors.datepurchase) {
        dispatch(warningErrorAction(t(errors.datepurchase)));
      } else if (formPurchaseDelivery.linespurchasedelivery===undefined  
        || formPurchaseDelivery.linespurchasedelivery.length===0 ) {
        dispatch(warningErrorAction(t('Text_FieldArticlesRequired')));
      } else{
        dispatch(warningErrorAction(t('Text_IncorrectData')));      
      }
    }
  };

  const validatePurchaseDelivery = () => {
    let errorsForm = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    if (regexInvalidCharacters.test(formPurchaseDelivery.ownnumberpurchase)) {
      errorsForm.ownnumberpurchase = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formPurchaseDelivery.opt_tras_documentid)) {
      errorsForm.opt_tras_documentid = 'Text_TextNoValid';
    }
    
    if (regexInvalidCharacters.test(formPurchaseDelivery.opt_tras_street)) {
      errorsForm.opt_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formPurchaseDelivery.opt_tras_email)) {
      errorsForm.opt_tras_email = 'Text_TextNoValid';
    }  
    if (regexInvalidCharacters.test(formPurchaseDelivery.opt_tras_licenseplate)) {
      errorsForm.opt_tras_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formPurchaseDelivery.vehiclestore_frame)) {
      errorsForm.vehiclestore_frame = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formPurchaseDelivery.vehicle_marca)) {
      errorsForm.vehicle_marca = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formPurchaseDelivery.vehicle_model)) {
      errorsForm.vehicle_model = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formPurchaseDelivery.observations)) {
      errorsForm.observations = 'Text_TextNoValid';
    } 
    if (formPurchaseDelivery.opt_tras_tradename===null  || formPurchaseDelivery.opt_tras_tradename===""){
      errorsForm.opt_tras_tradename = 'Text_TradenameRequired';
    }else{
      if (regexInvalidCharacters.test(formPurchaseDelivery.opt_tras_tradename)) {
        errorsForm.opt_tras_tradename = 'Text_TextNoValid';
      }
    } 
    if (formPurchaseDelivery.datepurchase===null  || formPurchaseDelivery.datepurchase===""){
      errorsForm.datepurchase = 'Text_DateRequired';
    }
    return errorsForm;
  };
  
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
   
  useEffect(() => {
    let isMounted = true;
    const fetchDataRoadType = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `purchasedelivery/roadtypesorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `purchasedelivery/roadtypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setRoadTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchDataPayment = async () => {
      try {
        const getData = i18n.language === "es"
        ? await helpHttp().get(ENDPOINT, `purchasedelivery/paymenttypesorderbynamees`, token)
        : await helpHttp().get(ENDPOINT, `purchasedelivery/paymenttypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setPaymenetTypeSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    if (showModalPurchasesDeliverySettings ) {  
      fetchDataPayment(); 
      fetchDataRoadType();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,showModalPurchasesDeliverySettings]);

   useEffect(() => {
      let isMounted = true; 
      const fetchDataPostalCodeOpt = async () => {
          try {
              const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getlistpostalcode/`,token,
                  (formPurchaseDelivery.opt_tras_postalcode_code!==undefined && formPurchaseDelivery.opt_tras_postalcode_code!==null && formPurchaseDelivery.opt_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.opt_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
              if (getData.err) {
                  dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                  setPostalCodeOptToSelect(getData);
              }
          } catch (error) {
              dispatch(warningErrorAction(t('Text_IncorrectData')));  
          }
      };  
      if (formPurchaseDelivery.opt_tras_postalcode_code && formPurchaseDelivery.opt_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataPostalCodeOpt();
      } 
      return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formPurchaseDelivery.opt_tras_postalcode_code,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormPurchaseDelivery]);

 useEffect(() => {
    let isMounted = true; 
    const fetchDataMarcaVehiclesType= async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getmarcavehicletypeslist/`,token,
          "-1"); 
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
              setMarcaToSelect(getData);
          }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData')));  
      }
    };  
    if (showModalPurchasesDeliverySettings){
      fetchDataMarcaVehiclesType();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,formPurchaseDelivery.vehicle_marca,showModalPurchasesDeliverySettings]);
    
  useEffect(() => {
    let isMounted = true;
    const fetchExistVehicle = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getexistsheetbylicenceplate/`,token,formPurchaseDelivery.opt_tras_licenseplate.replace(/[.\-/\\|]/g, ""));
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData>0 ){
              fetchSheetByLicencePlate();
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchSheetByLicencePlate = async () => {
        try {
            const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getsheetbylicenceplate/`,token,formPurchaseDelivery.opt_tras_licenseplate.replace(/[.\-/\\|]/g, ""));
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                if (getData!==undefined && getData!==null && getData!==""){
                    setFormPurchaseDelivery(formPurchaseDelivery => ({
                        ...formPurchaseDelivery,
                        opt_tras_licenseplate: getData.vehicle_sheet, 
                        vehicle_marca: getData.vehicle_marca,
                        vehicle_model: getData.vehicle_model,
                        vehiclestore_frame: getData.frame_sheet
                    }));
                }  
            }         
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };
    if (formPurchaseDelivery.opt_tras_licenseplate && formPurchaseDelivery.opt_tras_licenseplate.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistVehicle();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,formPurchaseDelivery.opt_tras_licenseplate,errorsForm.opt_tras_licenseplate,setFormPurchaseDelivery]);
  

  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberDocument = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getexiststorebynumberdocument/`,token,formPurchaseDelivery.opt_tras_documentid.replace(/[.\-/\\|]/g, ""));
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData>0 && getData!==formPurchaseDelivery.opt_tras_store_id){
              fetchStoreNumberDocument();
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchStoreNumberDocument = async () => {
        try {
            const getData = await helpHttp().get5(ENDPOINT,`purchasedelivery/getformstorebynumberdocument`,token,formPurchaseDelivery.opt_tras_documentid.replace(/[.\-/\\|]/g, ""),1);
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                if (getData!==undefined && getData!==null && getData!==""){
                    setFormPurchaseDelivery(formPurchaseDelivery => ({
                        ...formPurchaseDelivery,
                        opt_tras_store_id: getData.store_id,
                        opt_tras_documnettype_id: (getData.documnettype_id===undefined 
                                                || getData.documnettype_id===null  
                                                || getData.documnettype_id===""
                                                || getData.documnettype_id==="0"
                                                || getData.documnettype_id===0)?
                                                Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                        opt_tras_tradename: getData.tradename,
                        opt_tras_roadtype_id: (getData.roadtype_id===undefined 
                                                || getData.roadtype_id===null  
                                                || getData.roadtype_id===""
                                                || getData.roadtype_id==="0"
                                                || getData.roadtype_id===0)?
                                                Number(DEFAULTROADTYE):getData.roadtype_id,
                        opt_tras_street: getData.street,
                        opt_tras_country_id: (getData.country_id===undefined 
                                                || getData.country_id===null  
                                                || getData.country_id===""
                                                || getData.country_id==="0"
                                                || getData.country_id===0)?
                                                Number(DEFAULTCOUNTRY):getData.country_id,
                        opt_tras_country_name: (getData.country_name===undefined 
                                                || getData.country_name===null  
                                                || getData.country_name==="" )?
                                                DEFAULTCOUNTRY_NAME:getData.country_name,
                        opt_tras_province_id: (getData.province_id===undefined 
                                                || getData.province_id===null  
                                                || getData.province_id===""
                                                || getData.province_id==="0"
                                                || getData.province_id===0)?
                                                Number(DEFAULTPROVINCE):getData.province_id,
                        opt_tras_province_name: (getData.province_name===undefined 
                                                || getData.province_name===null  
                                                || getData.province_name==="" )?
                                                DEFAULTPROVINCE_NAME:getData.province_name, 
                        opt_tras_postalcode_id: (getData.postalcode_id===undefined 
                                                    || getData.postalcode_id===null  
                                                    || getData.postalcode_id===""
                                                    || getData.postalcode_id==="0"
                                                    || getData.postalcode_id===0)?
                                                    Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                        opt_tras_postalcode_code: (getData.postalcode_code===undefined 
                                                    || getData.postalcode_code===null  
                                                    || getData.postalcode_code==="" )?
                                                      DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                        opt_tras_postalcode_name:   (getData.postalcode_name===undefined 
                                                    || getData.postalcode_name===null  
                                                    || getData.postalcode_name==="" )?
                                                      DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                        opt_tras_community_id: (getData.community_id===undefined 
                                                    || getData.community_id===null  
                                                    || getData.community_id===""
                                                    || getData.community_id==="0"
                                                    || getData.community_id===0)?
                                                    Number(DEFAULTCOMMUNITY):getData.community_id,
                        opt_tras_community_name:   (getData.community_name===undefined 
                                                    || getData.community_name===null  
                                                    || getData.community_name==="" )?
                                                      DEFAULTCOMMUNITY_NAME:getData.community_name,  
                        opt_tras_email: getData.email
                    }));
                }  
            }         
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };
    if (formPurchaseDelivery.opt_tras_documentid && formPurchaseDelivery.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberDocument();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,formPurchaseDelivery.opt_tras_documentid,errorsForm.opt_tras_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTROADTYE,DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTTYPEOFDOCUMENT,DEFAULTPROVINCE,DEFAULTPROVINCE_NAME,setFormPurchaseDelivery,formPurchaseDelivery.opt_tras_store_id]);
  
  useEffect(() => {
    let isMounted = true; 
    const fetchDataDocumentIdOpt = async () => {
        try {
        const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getlistdocumentid/`,token,
            (formPurchaseDelivery.opt_tras_documentid!==undefined && formPurchaseDelivery.opt_tras_documentid!==null && formPurchaseDelivery.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setDocumentIdOptToSelect(getData); 
        }
        } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };   
    // if (formPurchaseDelivery.opt_tras_documentid && formPurchaseDelivery.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
      fetchDataDocumentIdOpt();
    //}
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formPurchaseDelivery.opt_tras_documentid]);
  
   useEffect(() => {
      let isMounted = true; 
      const fetchDataTradenameOpt = async () => {
          try {
              const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getListtradename/`,token,
                  (formPurchaseDelivery.opt_tras_tradename!==undefined && formPurchaseDelivery.opt_tras_tradename!==null && formPurchaseDelivery.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
              if (getData.err) {
                  dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                  setTradenameOptToSelect(getData);
              }
          } catch (error) {
              dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
      };  
      fetchDataTradenameOpt();
      return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formPurchaseDelivery.opt_tras_tradename]);
  
  useEffect(() => {
    let isMounted = true;
      const fetchDataModelVehiclesType = async () => {
      try {
        const getData = await helpHttp().get5(ENDPOINT,`purchasedelivery/getmodelvehicletypesList`, token,
          (formPurchaseDelivery.vehicle_marca && formPurchaseDelivery.vehicle_marca.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.vehicle_marca.replace(/[.\-/\\|]/g, "").trim():"-1",
          (formPurchaseDelivery.vehicle_model && formPurchaseDelivery.vehicle_model.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.vehicle_model.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setModelToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalPurchasesDeliverySettings && formPurchaseDelivery.vehicle_marca && formPurchaseDelivery.vehicle_marca.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchDataModelVehiclesType();  
    }else{
      setModelToSelect(initialModelToSelect);
    }
    return () => { isMounted = false }; 
  }, [t,token,dispatch,i18n,formPurchaseDelivery.id,formPurchaseDelivery.vehicle_marca,formPurchaseDelivery.vehicle_model,showModalPurchasesDeliverySettings]);
   
  useEffect(() => {
    let isMounted = true;
    const fetchDataPurchaseDelivery = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`purchasedelivery/getpurchasedeliverybyid/`,token,id);
        if (getData.err) {
          setFormPurchaseDelivery(initialStatePurchaseDelivery);
          setIsLoadingErrorData(true);
           dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setFormPurchaseDelivery(getData);
          dispatch(setLoading(false));
        }  
      } catch (error) {
         dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    if (id!=="0"){
      if (formPurchaseDelivery.id===""){
        fetchDataPurchaseDelivery();  
      }
    }else{
      setFormPurchaseDelivery(initialStatePurchaseDelivery);
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
        defaultStore_id:defaultStore.id,
        tradename:"",
        useraccount_id:useraccount_id,
        username:"",
        substore_id:Number(DEFAULTSUBSTORE),
        substore_name:"",
        purchasenote:"",
        ownnumberpurchase:"",
        datepurchase:new Date(),
        
        opt_tras_store_id: 0,
        opt_tras_documnettype_id: 1, 
        opt_tras_documentid:"",
        opt_tras_tradename:"", 
        opt_tras_roadtype_id: Number(DEFAULTROADTYE),
        opt_tras_street: "",
        opt_tras_country_id: Number(DEFAULTCOUNTRY),
        opt_tras_country_name:DEFAULTCOUNTRY_NAME,
        opt_tras_province_id: Number(DEFAULTPROVINCE),
        opt_tras_province_name:DEFAULTPROVINCE_NAME,
        opt_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
        opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
        opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
        opt_tras_community_id: Number(DEFAULTCOMMUNITY),
        opt_tras_community_name: DEFAULTCOMMUNITY_NAME,
        opt_tras_email:"",
        opt_tras_licenseplate:"",
        vehiclestore_frame:"", 
        vehicle_marca:"", 
        vehicle_model:"", 

        observations:"", 
        totalpurchasedelivery: 0,
        totaldiscountpurchasedelivery: 0,
        totaltaxespurchasedelivery: 0,
        totalNetoPurchasedelivery:0,
        payment_id:1, 
        payment_code: "",
        payment_namees: "",
        payment_nameen: "", 
        linespurchasedelivery: [] 

      }));
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
        linespurchasedelivery:[]
      })); 
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,formPurchaseDelivery.id,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,defaultStore.id,defaulttypesdi,useraccount_id,
    DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTCOUNTRY,DEFAULTPROVINCE,DEFAULTCOMMUNITY,DEFAULTCOMMUNITY_NAME
  ]); 

 return (
      <>
        {showModalPurchasesDeliverySettings ? ( 
          <div className="container-fluid">
            <Box sx={{ bgcolor: '#ffffff', width: '1050px'}}>
              <form className="createform" onSubmit={handleCloseDataEditPurchaseDelivery}>  
                <div className="row"> 
                  <div className="col-xl-12 mb-4"> 
                    <div  className="card border-info shadow">
                      <div className="card-body"> 
                        <div className="row no-gutters align-items-center">
                          <div className="col mr-2">
                            <div id="myDIV">
                                <h1 className={(typeOfList==="1" )?"h9NewStyle mb-2":"h9BNewStyle mb-2"}>
                                   {isLoadingErrorData?
                                  <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                                  (isLoadingData?
                                  <CircularProgress sx={{ color : "#f6c23e"}}/>:
                                  <i className="fas fa-regular fa-clipboard text-warning"></i>)} 
                                  &nbsp;&nbsp;{id==="0"?(typeOfList==="1"?t('TextPurchaseDeliverIn_New'):t('TextPurchaseDeliverOut_New'))+': '+formPurchaseDelivery.purchasenote:(typeOfList==="1"?t('Text_PurchaseDeliverIn_Edit'):t('Text_PurchaseDeliverOut_Edit'))+': '+formPurchaseDelivery.purchasenote}
                              </h1>
                              <div>
                              {isLoadingData?
                                <CircularProgress sx={{ color : "#f6c23e"}}/>:
                                  <>
                                    <button type="button" className="buttonCreate" onClick={handleSubmitDataEditPurchaseEdit}>
                                      {id==="0"?t('Button_Create'):t('Button_Update')}
                                    </button><> </>
                                    <button type="button" className="buttonBack" onClick={handleCloseDataEditPurchaseDelivery}>{t('Button_Cancel')}</button>
                                  </>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {!isLoadingData ?
                <>
                  <div className="row"> 
                    <div className="col-xl-12 "> 
                      <div  className="card border-info shadow">
                        <div className="card-body"> 
                          <div className="row no-gutters align-items-center">
                            <div className="row p-2"> 
                              <div className="form-group">   
                                <label className="text-danger" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_OWNNUMPURCHASE_UPPER').toUpperCase()} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="ownnumberpurchase" 
                                  name="ownnumberpurchase"
                                  value={formPurchaseDelivery.ownnumberpurchase}
                                  inputProps={{ style: {width: i18n.language==='es'?312:282,  fontSize: '18px', }, maxLength: 20 }}
                                  style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  label={errorsForm.ownnumberpurchase!=null?t(errorsForm.ownnumberpurchase):t('Text_PURCHASEDELIVERY_OWNNUMPURCHASE_UPPER')}
                                  placeholder={t('Text_PURCHASEDELIVERY_OWNNUMPURCHASE_UPPER')}
                                  variant="standard"
                                  onBlur={handleBlurDataEditPurchaseDelivery}
                                  onChange={handleChangeDataEditPurchaseDelivery}
                                />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                  <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_DATEPURCHAE').toUpperCase()} :</label>
                                  &nbsp;&nbsp;&nbsp;&nbsp; 
                                  <DesktopDatePicker
                                    id="datepurchase" 
                                    name="datepurchase"
                                    value={ formPurchaseDelivery.datepurchase!== null ? new Date(formPurchaseDelivery.datepurchase):null}
                                    format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                    inputProps={{ style: { width: 220 }, maxLength: 200 }}
                                    label={errorsForm.datepurchase!=null?t(errorsForm.datepurchase):t('Text_PurchaseDeliver_Date')}
                                    onBlur={handleBlurSelectDate}
                                    onChange={handleChangeSelectDate}
                                    slotProps={{
                                      textField: {
                                        placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                        sx: {
                                          maxLength: 220,
                                          width: 220,
                                          fontSize: '18px',  
                                        },
                                        InputProps: {
                                          style: {
                                            fontSize: '18px',
                                          }
                                        },
                                        InputLabelProps:{ 
                                          style: {
                                            fontSize: '18px', 
                                            background: '#FFFFFF'
                                          }
                                        },
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </div>
                              <div className="form-group">   
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PurchaseDeliver_LICENSEPLATE').toUpperCase()} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="opt_tras_licenseplate" 
                                  name="opt_tras_licenseplate"
                                  value={formPurchaseDelivery.opt_tras_licenseplate}
                                  inputProps={{ style: {width: 250,  fontSize: '18px', }, maxLength: 100 }}
                                  style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  label={errorsForm.opt_tras_licenseplate!=null?t(errorsForm.opt_tras_licenseplate):t('Placeholder_PURCHASEDELIVERY_LICENSEPLATE')}
                                  placeholder={t('Placeholder_PURCHASEDELIVERY_LICENSEPLATE')}
                                  variant="standard"
                                  onBlur={handleBlurDataEditPurchaseDelivery}
                                  onChange={handleChangeDataEditPurchaseDelivery}
                                />
                                &nbsp;&nbsp;
                                <IconButton  size="small"  style={{color:"#e74a3b", fontSize: 12}} onClick={deleteVehicleData}>
                                  <DeleteIcon style={{fontSize: 28}}/>
                                </IconButton>
                                &nbsp;&nbsp;
                                <IconButton  size="small"  style={{color:"#4e73df", fontSize: 12}} onClick={searchPurchaseSHEETS}>
                                  <SearchIcon style={{fontSize: 28}}/>
                                </IconButton>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_VEHICLE_FRAME').toUpperCase()} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="vehiclestore_frame" 
                                  name="vehiclestore_frame"
                                  value={formPurchaseDelivery.vehiclestore_frame}
                                  inputProps={{ style: {width: i18n.language==='es'?322:381,  fontSize: '18px', }, maxLength: 50 }}
                                  style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  label={errorsForm.vehiclestore_frame!=null?t(errorsForm.vehiclestore_frame):t('PlaceHolder_PURCHASE_VEHICLE_FRAME')}
                                  placeholder={t('PlaceHolder_PURCHASE_VEHICLE_FRAME')}
                                  variant="standard"
                                  onBlur={handleBlurDataEditPurchaseDelivery}
                                  onChange={handleChangeDataEditPurchaseDelivery}
                                />
                              </div>
                              <div className="form-group">   
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_VEHICLE_MARCA').toUpperCase()} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="vehicle_marca"
                                    name="vehicle_marca"
                                    value={formPurchaseDelivery.vehicle_marca}
                                    onChange={(e) => {
                                      setFormPurchaseDelivery(prev => ({
                                        ...prev,
                                        vehicle_marca: e.target.value.toUpperCase() 
                                      }));
                                      debouncedHandleSearchMarca(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownMarca}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsForm.vehicle_marca != null
                                      ? t(errorsForm.vehicle_marca)
                                      : t('Text_PURCHASE_VEHICLE_MARCA')}
                                    placeholder={t('Text_PURCHASE_VEHICLE_MARCA')}
                                    inputProps={{ style: {width: i18n.language==='es'?230:279,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                    variant="outlined" 
                                  />
                                  {filteredMarca.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: '0px',
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {filteredMarca.map((vehicletype, index) => (
                                        <MenuItem
                                          key={vehicletype.id}
                                          onClick={() => handleSelectMarca(vehicletype)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor: index === highlightedIndexMarca ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexMarca ? "white" : "black",
                                          }}
                                        >
                                          {vehicletype.marca}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )} 
                                </span> 
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_VEHICLE_MODEL').toUpperCase()} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <span style={{ position: "relative" }} >
                                  <TextField
                                    id="vehicle_model"
                                    name="vehicle_model"
                                    value={formPurchaseDelivery.vehicle_model}
                                    onChange={(e) => {
                                      setFormPurchaseDelivery(prev => ({
                                        ...prev,
                                        vehicle_model: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchModel(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownModel}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsForm.vehicle_model!=null && errorsForm.vehicle_model!==""?t(errorsForm.vehicle_model):t('Text_PURCHASE_VEHICLE_MODEL')}
                                    placeholder={t('Text_PURCHASE_VEHICLE_MODEL')}
                                    inputProps={{ style: {width: i18n.language==='es'?224:310,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    variant="outlined" 
                                  /> 
                                  {/* Desplegable dinámico */}
                                  {filteredModel.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: '0px',
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                    {filteredModel.map((vehicle, index) => (
                                      <MenuItem
                                        key={vehicle.id}
                                        onClick={() => handleSelectModel(vehicle)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexModel ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexModel ? "white" : "black",
                                        }}
                                      >
                                      {vehicle.model}
                                      </MenuItem>
                                    ))}
                                  </div>
                                  )}
                                </span>   
                              </div>
                              <div className="form-group">   
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_PROVIDER_TRADENAME').toUpperCase()} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="opt_tras_tradename"
                                    name="opt_tras_tradename"
                                    value={formPurchaseDelivery.opt_tras_tradename}
                                    onChange={(e) => {
                                        setFormPurchaseDelivery(prev => ({
                                        ...prev,
                                        opt_tras_tradename: e.target.value.toUpperCase()
                                        }));
                                        debouncedHandleSearchTradename(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownTradenameOpt}
                                    onBlur={(event) => {
                                        if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                        }
                                    }}
                                    label={errorsForm.opt_tras_tradename!=null && errorsForm.opt_tras_tradename!==""?t(errorsForm.opt_tras_tradename):t('PlaceHolder_PURCHASE_PROVIDER_TRADENAME')}
                                    placeholder={t('PlaceHolder_PURCHASE_PROVIDER_TRADENAME')}
                                    variant="standard"
                                    inputProps={{ style: {width: i18n.language==='es'?250:344,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  />  
                                  {/* Desplegable dinámico */}
                                  {filteredTradenamedOpt.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                          position: "absolute",
                                          left:'0px',
                                          border: "2px solid #4e73df", // Borde azul (#4e73df)
                                          borderRadius: "4px",
                                          marginTop: "4px",
                                          maxHeight: "200px",
                                          maxWidth: "750px",
                                          overflowY: "auto",
                                          width: "150%",
                                          fontSize: '18px',
                                          backgroundColor: "#f8f9fa", // Fondo gris claro
                                          zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                    {filteredTradenamedOpt.map((store, index) => (
                                      <MenuItem
                                        key={store.id}
                                        onClick={() => handleSelectTradeNameOpt(store)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexTradenamedOpt ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexTradenamedOpt ? "white" : "black",
                                        }}
                                      >
                                        {store.tradename} - {store.documentid}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                                </span> 
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_PROVIDER_DOCUMENT_ID').toUpperCase()} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="opt_tras_documentid"
                                    name="opt_tras_documentid"
                                    value={formPurchaseDelivery.opt_tras_documentid}
                                    onChange={(e) => {
                                        setFormPurchaseDelivery(prev => ({
                                        ...prev,
                                        opt_tras_documentid: e.target.value.toUpperCase()
                                        }));
                                        debouncedHandleSearchDocumentId(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownDocumentIdOpt}
                                    onBlur={(event) => {
                                        if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                        }
                                    }}
                                    label={errorsForm.opt_tras_documentid!=null && errorsForm.opt_tras_documentid!==""?t(errorsForm.opt_tras_documentid):t('Text_PURCHASE_PROVIDER_DOCUMENT_ID')}
                                    placeholder={t('Text_PURCHASE_PROVIDER_DOCUMENT_ID')}
                                    variant="standard"
                                    inputProps={{ style: {width: 200,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  /> 
                                  {/* Desplegable dinámico */}
                                  {filteredDocumentIdOpt.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                          position: "absolute",
                                          left:'0px',
                                          border: "2px solid #4e73df", // Borde azul (#4e73df)
                                          borderRadius: "4px",
                                          marginTop: "4px",
                                          maxHeight: "200px",
                                          maxWidth: "750px",
                                          overflowY: "auto",
                                          width: "150%",
                                          fontSize: '18px',
                                          backgroundColor: "#f8f9fa", // Fondo gris claro
                                          zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                    {filteredDocumentIdOpt.map((store, index) => (
                                      <MenuItem
                                        key={store.id}
                                        onClick={() => handleSelectDocumentIdOpt(store)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexDocumentIdOpt ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexDocumentIdOpt ? "white" : "black",
                                        }}
                                      >
                                        {store.documentid} - {store.tradename}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                                </span>  
                                &nbsp;&nbsp;
                                <IconButton  size="small"  style={{color:"#e74a3b", fontSize: 12}} onClick={deleteDateOptTras}>
                                  <DeleteIcon style={{fontSize: 28}}/>
                                </IconButton>
                                &nbsp;&nbsp;
                                <IconButton  size="small"  style={{color:"#4e73df", fontSize: 12}} onClick={searchPurchaseStore}>
                                  <SearchIcon style={{fontSize: 28}}/>
                                </IconButton>
                            </div>
                            <div className="form-group">   
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_RoadType')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <TextField
                                  id="opt_tras_roadtype_id"
                                  name="opt_tras_roadtype_id"
                                  value={ (formPurchaseDelivery.opt_tras_roadtype_id === undefined || formPurchaseDelivery.opt_tras_roadtype_id ===null || formPurchaseDelivery.opt_tras_roadtype_id ===""
                                      || formPurchaseDelivery.opt_tras_roadtype_id ==="0" || formPurchaseDelivery.opt_tras_roadtype_id ===0)?Number(DEFAULTROADTYE):formPurchaseDelivery.opt_tras_roadtype_id}
                                  inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  variant="outlined"
                                  onBlur={handleBlurDataEditPurchaseDelivery}
                                  onChange={handleChangeDataEditPurchaseDelivery}
                                  helperText={errorsForm.opt_tras_roadtype_id!=null && errorsForm.opt_tras_roadtype_id!==""?t(errorsForm.opt_tras_roadtype_id):""}
                                  select
                                  SelectProps={{
                                      native: true,
                                      value: (formPurchaseDelivery.opt_tras_roadtype_id === undefined || formPurchaseDelivery.opt_tras_roadtype_id ===null || formPurchaseDelivery.opt_tras_roadtype_id ===""
                                          || formPurchaseDelivery.opt_tras_roadtype_id ==="0" || formPurchaseDelivery.opt_tras_roadtype_id ===0)?Number(DEFAULTROADTYE): formPurchaseDelivery.opt_tras_roadtype_id
                                  }}>
                                  <option key={0} value=""/>
                                  {roadTypesToSelect.map((option) => (
                                      <option key={option.id} value={option.id}>
                                          {i18n.language==="es"?option.namees:option.nameen}
                                      </option>
                                  ))}
                              </TextField>  
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_Address').toUpperCase()} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <TextField
                                id="opt_tras_street" 
                                name="opt_tras_street"
                                value={formPurchaseDelivery.opt_tras_street}
                                inputProps={{ style: {width: i18n.language==='es'?497:515,  fontSize: '18px', }, maxLength: 250 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.opt_tras_street!=null?t(errorsForm.opt_tras_street):t('PlaceHolder_PURCHASE_Address')}
                                placeholder={t('PlaceHolder_PURCHASE_Address')}
                                variant="standard"
                                onBlur={handleBlurDataEditPurchaseDelivery}
                                onChange={handleChangeDataEditPurchaseDelivery}
                              />
                              &nbsp;&nbsp;
                              <IconButton  size="small"  style={{color:"#e74a3b", fontSize: 12}} onClick={deleteDataSteetOptTras}>
                                <DeleteIcon style={{fontSize: 28}}/>
                              </IconButton>
                              &nbsp;&nbsp;
                              <IconButton  size="small"  style={{
                                color:
                                (formPurchaseDelivery.opt_tras_store_id===undefined
                                || formPurchaseDelivery.opt_tras_store_id===""
                                || formPurchaseDelivery.opt_tras_store_id==="0"
                                || formPurchaseDelivery.opt_tras_store_id===0 )?"#858796":"#4e73df", fontSize: 18}} 
                                disabled={formPurchaseDelivery.opt_tras_store_id===undefined
                                        || formPurchaseDelivery.opt_tras_store_id===""
                                        || formPurchaseDelivery.opt_tras_store_id==="0"
                                        || formPurchaseDelivery.opt_tras_store_id===0 } onClick={searchPurchaseStoreAddress}>
                              <SearchIcon style={{fontSize: 28}}/>
                            </IconButton> 
                            </div>
                            <div className="form-group">   
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_PostalCode')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <span style={{ position: "relative" }}>
                                <TextField
                                  id="opt_tras_postalcode_code"
                                  name="opt_tras_postalcode_code"
                                  value={formPurchaseDelivery.opt_tras_postalcode_code}
                                  onChange={(e) => {
                                    setFormPurchaseDelivery(prev => ({
                                      ...prev,
                                      opt_tras_postalcode_code: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchPostalCode(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownDPostalCodeOpt}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      const inputPostalCode = formPurchaseDelivery.opt_tras_postalcode_code.trim().toUpperCase();
                                      const matchedPostal = postalCodeOptToSelect.find((postal) => {
                                        const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                        return normalizedPostal === inputPostalCode;
                                      });
                                      if (matchedPostal) {
                                        setFormPurchaseDelivery((prev) => ({
                                          ...prev,
                                            opt_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            opt_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            opt_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            opt_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE), 
                                            opt_tras_province_name: matchedPostal.province_name || DEFAULTPROVINCE_NAME
                                        }));
                                      } else {
                                          setFormPurchaseDelivery((prev) => ({
                                              ...prev,
                                              opt_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                              opt_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                              opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                              opt_tras_province_id: Number(DEFAULTPROVINCE),
                                              opt_tras_province_name: DEFAULTPROVINCE_NAME
                                          }));
                                      }
                                      setFilteredpostalCodeOpt([]);
                                      setHighlightedIndexPostalCodeOpt(-1);
                                    }
                                  }}
                                  label={errorsForm.opt_tras_postalcode_code!=null && errorsForm.opt_tras_postalcode_code!==""?t(errorsForm.opt_tras_postalcode_code):t('Text_PURCHASE_PostalCode')}
                                  placeholder={t('Text_PURCHASE_PostalCode')}
                                  variant="standard"
                                  inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                />  
                                {/* Desplegable dinámico */}
                                {filteredpostalCodeOpt.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                        position: "absolute",
                                        left:'0px',
                                        border: "2px solid #4e73df", // Borde azul (#4e73df)
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "700%", 
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa", // Fondo gris claro
                                        zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                  {filteredpostalCodeOpt.map((postal, index) => (
                                    <MenuItem
                                        key={postal.id}
                                        onClick={() => handleSelectPostalCodeOpt(postal)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexPostalCodeOpt ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexPostalCodeOpt ? "white" : "black",
                                        }}
                                    >
                                      {postal.postalcode} - {postal.name} - {postal.province_name}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_Locality')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                               <TextField
                                id="opt_tras_postalcode_name" 
                                name="opt_tras_postalcode_name"
                                value={formPurchaseDelivery.opt_tras_postalcode_name}
                                inputProps={{ style: {width:  275,  fontSize: '18px', }, maxLength: 100 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.opt_tras_postalcode_name!=null?t(errorsForm.opt_tras_postalcode_name):t('Text_PURCHASE_Locality')}
                                placeholder={t('Text_PURCHASE_Locality')}
                                variant="standard"
                                disabled
                              />
                               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASE_Email')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                               <TextField
                                id="opt_tras_email" 
                                name="opt_tras_email"
                                value={formPurchaseDelivery.opt_tras_email}
                                inputProps={{ style: {width:  i18n.language==='es'?252:282,  fontSize: '18px', }, maxLength: 100 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.opt_tras_email!=null?t(errorsForm.opt_tras_email):t('PlaceHolder_PURCHASE_Email')}
                                placeholder={t('PlaceHolder_PURCHASE_Email')}
                                variant="standard"
                              />
                            </div>
                            <div className="form-group"> 
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_TRADENAME_STORE_OTHERS').toUpperCase()} :</label>    
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <TextField
                                id="observations" 
                                name="observations"
                                value={formPurchaseDelivery.observations}
                                inputProps={{ style: {width: i18n.language==='es'?833:849,  fontSize: '18px', }, maxLength: 255 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                placeholder={t('Placeholder_PURCHASEDELIVERY_TRADENAME_STORE_OTHERS')}
                                variant="standard"
                                onBlur={handleBlurDataEditPurchaseDelivery}
                                onChange={handleChangeDataEditPurchaseDelivery}
                              />
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PurchaseDeliver_Payment').toUpperCase()} :</label>    
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <TextField
                                id="payment_id"
                                name="payment_id"
                                value={ (formPurchaseDelivery.payment_id === undefined || formPurchaseDelivery.payment_id ===null || formPurchaseDelivery.payment_id ===""
                                      || formPurchaseDelivery.payment_id ==="0" || formPurchaseDelivery.payment_id ===0)?2:formPurchaseDelivery.payment_id}
                                inputProps={{ style: {width: i18n.language==='es'?300:320,  fontSize: '18px', }, maxLength: 100 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                variant="outlined"
                                onBlur={handleBlurDataEditPurchaseDelivery}
                                onChange={handleChangeDataEditPurchaseDelivery}
                                select
                                SelectProps={{
                                  native: true,
                                  value: (formPurchaseDelivery.payment_id === undefined || formPurchaseDelivery.payment_id ===null || formPurchaseDelivery.payment_id ===""
                                      || formPurchaseDelivery.payment_id ==="0" || formPurchaseDelivery.payment_id ===0)?2: formPurchaseDelivery.payment_id
                                }}> 
                                {paymenetTypeSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                                ))}
                              </TextField>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PurchaseDeliver_TOTAL').toUpperCase()} :</label>    
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <NumericFormat 
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {2}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap3}
                                id="totalNetoPurchasedelivery" 
                                name="total"
                                suffix=' €'
                                value={formPurchaseDelivery.totalNetoPurchasedelivery}
                                style={{width:i18n.language==='es'?262:349, color:"#red", background:"#black",fontSize: 28, textAlign:'right', paddingRight:5}} 
                                disabled
                              />   
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <PurchaseSelectArticle
                                  newArticle={newArticle}
                                  setNewArticle={setNewArticle}
                                  errorNewArticle={errorNewArticle} 
                                  setErrorNewArticle={setErrorNewArticle}
                                  foundArticle={foundArticle}
                                  setFoundArticle={setFoundArticle}
                                  foundNumSerial={foundNumSerial}
                                  setFoundNumSerial={setFoundNumSerial}
                                  colorToSelect={colorToSelect}
                                  setColorToSelect={setColorToSelect}
                                  typesOfSizeToSelect={typesOfSizeToSelect}
                                  setTypesOfSizeToSelect={setTypesOfSizeToSelect}
                                  serialNumbersToSelect={serialNumbersToSelect}
                                  setSerialNumbersToSelect={setSerialNumbersToSelect}
                                  formPurchaseDelivery={formPurchaseDelivery}
                                  setFormPurchaseDelivery={setFormPurchaseDelivery} 
                                  setShowModalSearchArticles={setShowModalSearchArticles}
                                  typeOfList={typeOfList}
                              />
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <TableSortingPurchaseDeliveryArticleList
                                dataArticles={formPurchaseDelivery.linespurchasedelivery} 
                                numTotRegArticles={formPurchaseDelivery.linespurchasedelivery.length}
                                setOpenDeleteRowArticles={setOpenDeleteRowArticles}
                                setEditRowArticles={setEditRowArticles}
                                formPurchaseDelivery={formPurchaseDelivery}                                  
                                setFormPurchaseDelivery={setFormPurchaseDelivery}
                                setShowModalSearchArticles={setShowModalSearchArticles}
                              />
                              <hr className="sidebar-divider d-none d-md-block"/>
                                
                               
                            </div>                              
                          </div>
                        </div>   
                      </div>
                    </div>
                  </div>
                </div>
                <PurchaseSearchStores
                  showModalSearchStores={showModalSearchStores}
                  setShowModalSearchStores={setShowModalSearchStores}
                  selectStores={"Opt_Tras"}
                  setFormPurchaseDelivery={setFormPurchaseDelivery}
                />
                <PurchaseSearchStoresAddresses
                    showModalSearchStoresAddress={showModalSearchStoresAddress}
                    setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                    selectStores={"Opt_Tras"}
                    setFormPurchaseDelivery={setFormPurchaseDelivery}
                    titleTable={formPurchaseDelivery.opt_tras_tradename}
                    store_id={formPurchaseDelivery.opt_tras_store_id}
                    priority={1}
                />
                <PurchaseSearchSHEETS
                  showModalSearchSHEETS={showModalSearchSHEETS}
                  setShowModalSearchSHEETS={setShowModalSearchSHEETS}
                  selectStores={"Opt_Tras"}
                  setFormPurchaseDelivery={setFormPurchaseDelivery}
                />
                <PurchaseDeliverySearchArticles
                  showModalSearchArticles={showModalSearchArticles}
                  setShowModalSearchArticles={setShowModalSearchArticles}                     
                  setNewArticle={setNewArticle} 
                /> 
                <Dialog open={openDeleteRowArticles} onClose={handleCancelDeleteRow}>
                  <DialogTitle style={{color:"#e74a3b"}}>{t('Text_Delete')} {editRowArticles.article_code} - {i18n.language==='es'?editRowArticles.article_namees:editRowArticles.article_nameen} </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      {t('Text_Line1')}<br/>
                      {t('Text_Line2')}
                    </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="idCode"
                      label={t('Text_Label')}
                      type="text"
                      fullWidth
                      variant="standard"
                      error
                      defaultValue={idCodeDeletePurchaseDelivery}
                      onChange={handleChangeDeleteRow}/>
                  </DialogContent>
                  <DialogActions>
                    <Button style={{color:"#e74a3b",fontSize: 16 }} onClick={handleCancelDeleteRow}>{t('Button_Cancel')}</Button>
                    <Button variant="contained" style={{color:"#ffffff", background:"#e74a3b",fontSize: 16}} onClick={handleCloseDeleteRow}>{t('Button_Delete')}</Button>
                  </DialogActions>
                </Dialog>
              </>:
                <LoadingNews/>
              }
            </form>
          </Box> 
           
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )    
}

PurchaseDeliveryEditOrCreate.propTypes = {
  id: PropTypes.string.isRequired,
  showModalPurchasesDeliverySettings: PropTypes.bool.isRequired,
  typeOfList: PropTypes.string.isRequired
};

export default PurchaseDeliveryEditOrCreate;